import { z } from 'zod';
import { eobSchema } from './eob';
import { payorSchema } from './payor';
import { providerSchema } from './provider';
import { tariffSchema } from './tariff';
import { remittanceLineSchema } from './remittanceLine';

export const debitSchema = z.object({
  id: z.string(),
  claimID: z.uuid().nullable(),
  payorID: z.uuid().nullable(),
  providerID: z.uuid().nullable(),
  tariffID: z.uuid().nullable(),
  requestedAmount: z.string().nullable(),
  paidAmount: z.string().nullable(),
  adjustment: z.string().nullable(),
  microfilm: z.string().nullable(),
  createdAt: z.coerce.date(),
  createdBy: z.uuid().nullable().optional(),
  remittanceLineID: z.uuid().nullable().optional(),
  status: z.enum(['processed', 'pending']).nullable(),
  type: z.enum(['RETRACTION', 'INFO', 'PAYMENT']).nullable(),
  source: z.enum(['REMITTANCE', 'MANUAL', 'EXTERNAL_PAYMENT']).nullable(),
  payor: z.lazy(() => payorSchema).nullable(),
  eobs: z.lazy(() => eobSchema.array()),
  provider: z
    .lazy(() => providerSchema)
    .optional()
    .nullable(),
  tariff: z
    .lazy(() => tariffSchema.partial())
    .optional()
    .nullable(),
  remittanceLine: z
    .lazy(() => remittanceLineSchema)
    .optional()
    .nullable(),
});
